import { createAction } from 'redux-actions';

export const INITIAL_STEP = 'INITIAL_STEP';
export const NEXT_STEP = 'NEXT_STEP';

export const goToInitialStep = createAction(INITIAL_STEP);
export const goToNextStep = createAction(NEXT_STEP, options => ({ options }));
